import React, { useEffect, useState } from "react";
import RevenueReportTable from "./RevenueReportTable";
import RevenueFilter from "./RevenueFilter";
import useEngagementStore from "./store";
import CardDiv from "modules/common/card-div/CardDiv";
import {
  getFormattedStartDate,
  getFormattedEndDate,
  revenueRepStartDate,
  revenueRepEndDate,
} from "functionCall";
import { getCurrentUserRole } from "modules/utilities/utility";

const RevenueReport = ({ tab }) => {
  const [startDate, setStartDate] = useState(getFormattedStartDate());
  const [endDate, setEndDate] = useState(getFormattedEndDate(1));
  const [repStartDate, setRepStartDate] = useState(
    revenueRepStartDate(startDate)
  );
  const [repEndDate, setRepEndDate] = useState(revenueRepEndDate(endDate));
  const [dateFilter, setDateFilter] = useState(false);
  const [startFilterDate, setStartDateFilter] = useState("");
  const [endFilterDate, setEndDateFilter] = useState("");
  const { revenueData, isLoading, error, fetchRepData } = useEngagementStore();

  useEffect(() => {
    if ((tab == "revenue-report")) {
      if (dateFilter) {
        fetchRepData(repEndDate, repStartDate);
        return;
      }
      if (startFilterDate && endFilterDate) {
        let repStart = revenueRepStartDate(startFilterDate);
        let repEnd = revenueRepEndDate(endFilterDate);
        fetchRepData(repStart, repEnd);
      } else {
        fetchRepData(repEndDate, repStartDate);
      }
    }
  }, [startFilterDate, endFilterDate, dateFilter,tab]);

  const columns = [
    "Hair Coach",
    "Type",
    "Total Repeat Orders",
    "CRM placed repeat orders",
    "Order placed from My UTM",
    "Order via Whatsapp",
    "Direct customer",
    "RTO- CRM Placed repeat orders",
    "Cancelled- CRM Placed repeat orders	",
    "AOV",
  ];
  if (error) {
    return <CardDiv component={<h1>Revenue Report not found</h1>} />;
  }

  return ["medical_rep", "medrep_ext", "operations"].includes(
    getCurrentUserRole()
  ) ? (
    <CardDiv
      title={
        <div className="d-flex justify-content-between">
          <div className="fs-2 mt-2">Revenue Report</div>
          <RevenueFilter
            setStartDateFilter={setStartDateFilter}
            setEndDateFilter={setEndDateFilter}
            dateFilter={dateFilter}
            setDateFilter={setDateFilter}
          />
        </div>
      }
      component={
        <RevenueReportTable
          className="mt-1"
          columns={columns}
          revenueData={revenueData}
          isLoading={isLoading}
          error={error}
        />
      }
    />
  ) : (
    <div className="fs-1">Revenue Report not found</div>
  );
};

export default RevenueReport;
